import type { Database } from "@/integrations/supabase/types";
import type { SalesExplorerFilters } from "./types";

const listOrNull = (values: string[]): string[] | null => (values.length > 0 ? values : null);

const textOrNull = (value: string): string | null => {
  const trimmed = value.trim();
  return trimmed.length > 0 ? trimmed : null;
};

/**
 * Na RPC, NULL significa "sem filtro". Array vazio significaria "não casa com
 * nada", então lista vazia e texto em branco precisam virar null aqui.
 */
export function buildExplorerRpcParams(filters: SalesExplorerFilters): Database["public"]["Functions"]["search_sales_explorer"]["Args"] {
  return {
    p_from: filters.from,
    p_to: filters.to,
    p_appointment_type_ids: listOrNull(filters.appointmentTypeIds),
    p_appointment_statuses: listOrNull(filters.appointmentStatuses),
    p_professional_ids: listOrNull(filters.professionalIds),
    p_financial_status: filters.financialStatus,
    p_item_ids: listOrNull(filters.itemIds),
    p_item_types: listOrNull(filters.itemTypes),
    p_category_ids: listOrNull(filters.categoryIds),
    p_item_count_operator: filters.itemCount?.operator ?? null,
    p_item_count_value: filters.itemCount?.value ?? null,
    p_item_count_scope: filters.itemCount?.scope ?? "all",
    p_species_ids: listOrNull(filters.speciesIds),
    p_breed_ids: listOrNull(filters.breedIds),
    p_size_category_ids: listOrNull(filters.sizeCategoryIds),
    p_weight_min: filters.weightMin,
    p_weight_max: filters.weightMax,
    p_owner_search: textOrNull(filters.ownerSearch),
    p_owner_city: textOrNull(filters.ownerCity),
    p_owner_neighborhood: textOrNull(filters.ownerNeighborhood),
    p_page: filters.page,
    p_page_size: filters.pageSize,
  };
}
